import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"

export const getJobLineItems = (marinaSlug, jobId, params = {}) => {
  const qs = buildQueryString(params)
  return queryApi(
    `/manage/${marinaSlug}/service/jobs/${jobId}/line_items.json${qs}`
  )
}

export const createJobLineItem = (
  marinaSlug,
  jobId,
  { productId, pricePerUnit, quantity, notes }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/jobs/${jobId}/line_items`,
    method: "POST",
    data: {
      line_item: {
        product_id: productId,
        price_per_unit: pricePerUnit,
        quantity,
        notes,
      },
    },
  }).then((response) => response.data)

export const updateJobLineItem = (
  marinaSlug,
  jobId,
  lineItemId,
  { pricePerUnit, quantity, notes }
) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/jobs/${jobId}/line_items/${lineItemId}`,
    method: "PATCH",
    data: {
      line_item: {
        price_per_unit: pricePerUnit,
        quantity,
        notes,
      },
    },
  }).then((response) => response.data)

export const deleteJobLineItem = (marinaSlug, jobId, lineItemId) =>
  mutateApi({
    url: `/manage/${marinaSlug}/service/jobs/${jobId}/line_items/${lineItemId}`,
    method: "DELETE",
  }).then((response) => response.data)
